import React from 'react';
import NavBar2 from '../Components/NavBar2';

function SenderIdTemplates() {
  return (

    <div>
<NavBar2/>
    <div className="container py-5 mt-5">
      <h1 className="mb-4">Sender ID Registration Templates</h1>
      <p className="lead">
        Download pre-formatted MS Word templates for applying for a custom Sender ID with 
        Safaricom, Airtel, or Telkom Kenya. Customize the content with your business details, 
        print, sign, and submit your application.
      </p>

      <div className="row mt-4">
        {/* Safaricom Template */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">Safaricom Sender ID Template</h5>
              <p className="card-text">
                Official template for registering a Sender ID with Safaricom Kenya.
              </p>
              <a
                href="https://firebasestorage.googleapis.com/v0/b/kuzapoints.firebasestorage.app/o/Templates%2Fsafaricom.docx?alt=media&token=1efe36db-6fc1-42ff-8797-28a4cd60b33c"
                className="btn btn-success"
                download
              >
                Download .docx
              </a>
            </div>
          </div>
        </div>

        {/* Airtel Template */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">Airtel Sender ID Template</h5>
              <p className="card-text">
                Use this form to apply for a Sender ID with Airtel Kenya.
              </p>
              <a
                href="https://firebasestorage.googleapis.com/v0/b/kuzapoints.firebasestorage.app/o/Templates%2Fairtel.docx?alt=media&token=e2fc93c3-ac2c-4247-91b6-a9211a42c18b"
                className="btn btn-danger"
                download
              >
                Download .docx
              </a>
            </div>
          </div>
        </div>

        {/* Telkom Template */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <h5 className="card-title">Telkom Sender ID Template</h5>
              <p className="card-text">
                Apply for a custom Sender ID with Telkom Kenya using this template.
              </p>
              <a
                href="https://firebasestorage.googleapis.com/v0/b/kuzapoints.firebasestorage.app/o/Templates%2Ftelkom.docx?alt=media&token=a7e075ac-311b-4d7e-b05d-19c7c6451ac4"
                className="btn btn-warning text-white"
                download
              >
                Download .docx
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

  );
}

export default SenderIdTemplates;
